import React, { useContext, useState } from "react";
import { FieldPath, FieldValues } from "react-hook-form";
import { GroupBase } from "react-select";
import {
  ReactSelectSyncProps,
  ReactSelectAsyncProps,
  ReactSelectController,
  ReactSelectControllerProps,
} from "@pushpress/shared-components";
import { AppContext } from "../../../../context/app";
import { getMembers } from "../../../../apis/userApi";

interface Value {
  uuid: string;
  name: string;
}

type MemberSelectProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  Option extends Value,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = ReactSelectControllerProps<TFieldValues, TName, Option, IsMulti, Group>;

function MemberSelect<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  Option extends Value,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: MemberSelectProps<TFieldValues, TName, Option, IsMulti, Group> &
    (ReactSelectSyncProps | ReactSelectAsyncProps),
) {
  const { ...other } = props;

  const app = useContext(AppContext);

  const [inputValue, setInputValue] = useState("");

  const getOptionLabel = (option: Value) => {
    return option.name;
  };

  const getOptionValue = (option: Value) => {
    return option.uuid;
  };

  const handleLoadOptions = async (inputValue: string) => {
    setInputValue(inputValue);
    return await getMembers(app.client.uuid, inputValue);
  };

  const menuIsOpen = inputValue !== "";

  return (
    <ReactSelectController
      menuPortalTarget={document.body}
      {...other}
      async
      inputValue={inputValue}
      menuIsOpen={menuIsOpen}
      hideDropdownIndicator
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      loadOptions={handleLoadOptions}
      onInputChange={setInputValue}
    />
  );
}

export default MemberSelect;
